module.exports = __webpack_public_path__ + "static/sec5-bg-eea7c18cfbf7cd9f32e1a73f76469232.jpg";